interface LoadingChatMessageProps {
  color?: string
}

const LoadingChatMessage = ({ color = 'white' }: LoadingChatMessageProps) => {

  return (
    <div className="flex items-center justify-center m-auto">
    <div className="flex h-5 items-center gap-1">
      <div className="h-1.5 w-1.5 rounded-full animate-bounce" style={{ animationDelay: '0ms', backgroundColor: color }}></div>
      <div className="h-1.5 w-1.5 rounded-full animate-bounce" style={{ animationDelay: '200ms', backgroundColor: color }}></div>
      <div className="h-1.5 w-1.5 rounded-full animate-bounce" style={{ animationDelay: '400ms', backgroundColor: color }}></div>
    </div>
  </div>
  )
}

export default LoadingChatMessage
